import { render, staticRenderFns } from "./ResetToNorth.vue?vue&type=template&id=48969702&scoped=true&"
import script from "./ResetToNorth.vue?vue&type=script&lang=ts&"
export * from "./ResetToNorth.vue?vue&type=script&lang=ts&"
import style0 from "./ResetToNorth.vue?vue&type=style&index=0&id=48969702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48969702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
